import * as actions from './actions';

export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.END:
      return {
        ...state,
        userSettings: action.userSettings,
        origSettings: action.origSettings,
        afterRegistration: action.afterRegistration,
        changes: 0,
      };
    case actions.SAVE.END:
      return {
        ...state,
        origSettings: action.origSettings,
        changes: 0,
      };
    case actions.INVALIDATE:
      return {
        ...state,
        changes: action.changes,
      };
    case actions.RESET_CHANGES.END:
      return {
        ...state,
        userSettings: action.userSettings,
        changes: 0,
      };
    case actions.SET_FIRST_NAME:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          firstName: action.value,
        },
      };
      case actions.SET_COMPANY:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          company: action.value,
        },
      };
      case actions.SET_PHONE:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          phone: action.value,
        },
      };
    case actions.SET_LAST_NAME:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          lastName: action.value,
        },
      };
    case actions.SET_ABOUT_ME:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          aboutMe: action.value,
        },
      };
      case actions.SET_LANGUAGE:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          selectedLanguage: action.value,
        },
      };
    case actions.SET_AVATAR:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          avatarUrl: action.avatar,
        },
        origSettings: {
          ...state.origSettings,
          avatarUrl: action.avatar,
        }
      };
    case actions.SET_RECEIVE_EMAIL:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          companies: state.userSettings.companies.map(company => company === action.item ? {
            ...company,
            receiveIssueChangeEmail: action.value
          } : company)
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/personal/reducer.js